import { Title } from '../../components/Title/Title';
import { Topbar } from '../../components/Topbar/Topbar';
import { Alert, Breadcrumb, Button, Card, Container, Modal } from 'react-bootstrap';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Footer } from '../../components/Footer/Footer';
import { useEffect, useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { faLevelUpAlt } from '@fortawesome/free-solid-svg-icons';
import './Upload.scss';
import { format, parseISO } from 'date-fns';
import { it } from 'date-fns/locale';
import filesize from 'filesize';
import { faGoogleDrive } from '@fortawesome/free-brands-svg-icons';

const UploadComponent = () => {
  const { queryGoogleDrive } = useFirebase();

  const [breadcrumb, setBreadcrumb] = useState([
    {
      path: '',
      label: <FontAwesomeIcon icon={faGoogleDrive} />,
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [folders, setFolders] = useState([]);
  const [foldersNextPageToken, setFoldersNextPageToken] = useState<string>(null);
  const [files, setFiles] = useState([]);
  const [filesNextPageToken, setFilesNextPageToken] = useState<string>(null);

  const [selectedFile, setSelectedFile] = useState<any>({});
  const [selectFileModal, setSelectFileModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [uploadError, setUploadError] = useState<any>(null);

  useEffect(() => {
    const folder = breadcrumb[breadcrumb.length - 1].path;
    runQuery({ folder }).catch(console.error);
  }, [breadcrumb]);

  const runQuery = async ({ folder }) => {
    setLoading(true);
    queryGoogleDrive('LISTALL', { folder })
      .then((res) => {
        setFolders(res.folders);
        setFiles(res.files);
        setFoldersNextPageToken(res.nextPageToken.folders);
        setFilesNextPageToken(res.nextPageToken.files);
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  };

  const formatDate = (iso: string) => {
    if (!iso) return '';
    return format(parseISO(iso), 'dd MMM y, HH:mm', { locale: it });
  };

  const formatSize = (size: string) => {
    if (!size) return '0 B';
    return filesize(+size);
  };

  useEffect(() => {
    if (selectedFile.id && !selectFileModal) {
      setUploadModal(true);
      queryGoogleDrive('TOS3', { fileId: selectedFile.id, fileName: selectedFile.name })
        .then((response) => {
          if (response.success) setUploadModal(false);
          else setUploadError(response);
        })
        .catch((err) => {
          console.error(err);
          setUploadError(err);
        });
    }
  }, [selectedFile, selectFileModal]);

  return (
    <>
      <Title>Upload</Title>

      <div style={{ marginBottom: '72px' }}>
        <div style={{ backgroundColor: '#141414', position: 'fixed', top: '0', left: '0', right: '0', zIndex: 100 }}>
          <Topbar />
        </div>
      </div>

      <Container className={'my-5'}>
        <div className={'d-flex align-items-center'}>
          <div className={'display-4'}>Upload</div>
        </div>

        <Breadcrumb className={'mt-4 upload-breadcrumb'}>
          {breadcrumb.map((item, index, arr) => (
            <Breadcrumb.Item
              key={item.path}
              active={index == arr.length - 1}
              onClick={() => {
                if (index == arr.length - 1) return;
                if (loading) return;
                const newBreadcrumb = breadcrumb.slice(0, index + 1);
                setBreadcrumb(newBreadcrumb);
              }}
            >
              {item.label}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>

        {loading && <FullscreenLoader fullscreen={false} />}
        {!loading && (
          <>
            <Card bg={'dark'}>
              <div className={'d-flex'}>
                <div style={{ flex: 1, borderRight: '1px solid #141414' }} className={'list-container'}>
                  {breadcrumb.length > 1 && (
                    <div
                      className={'file-list-item'}
                      onClick={() => {
                        const newBreadcrumb = breadcrumb.slice();
                        newBreadcrumb.pop();
                        setBreadcrumb(newBreadcrumb);
                      }}
                    >
                      <div className={'d-flex align-items-center'}>
                        <FontAwesomeIcon icon={faLevelUpAlt} flip={'horizontal'} fixedWidth={true} className={'mr-2'} />
                        <span>..</span>
                      </div>
                    </div>
                  )}
                  {!!folders.length &&
                    folders.map((folder) => (
                      <div
                        key={folder.id}
                        className={'file-list-item'}
                        onClick={() => {
                          const newItem = {
                            path: folder.id,
                            label: folder.name,
                          };
                          setBreadcrumb((current) => [...current, newItem]);
                        }}
                      >
                        <div className={'d-flex align-items-center'}>
                          <img src={folder.iconLink} alt={null} className={'mr-2'} />
                          <span>{folder.name}</span>
                        </div>
                      </div>
                    ))}
                  {!!foldersNextPageToken && <div className={'file-list-item file-list-item-link'}>Carica altro...</div>}
                </div>
                <div style={{ flex: 2 }} className={'list-container'}>
                  {files.length ? (
                    files.map((file) => (
                      <div
                        key={file.id}
                        className={'file-list-item'}
                        onClick={() => {
                          setSelectedFile(file);
                          setSelectFileModal(true);
                        }}
                      >
                        <div className={'d-flex align-items-center'}>
                          <img src={file.iconLink} alt={null} className={'mr-2'} />
                          <span className={'flex-grow-1'}>{file.name}</span>
                          <span className={'small text-muted'}>
                            {formatDate(file.modifiedTime)} &ndash; {formatSize(file.size)}
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className={'file-list-item empty-list text-muted'}>Nessun file in questo percorso.</div>
                  )}
                  {!!filesNextPageToken && <div className={'file-list-item file-list-item-link'}>Carica altro...</div>}
                </div>
              </div>
            </Card>
          </>
        )}
      </Container>

      <Footer />

      <Modal show={selectFileModal} onHide={() => setSelectFileModal(false)} backdrop={'static'} keyboard={false}>
        <Modal.Header>
          <Modal.Title>File selezionato</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Hai selezionato il file: "<strong>{selectedFile.name}</strong>"
          </div>
          <div className={'small'}>
            Percorso:{' '}
            {breadcrumb
              .slice(1)
              .map((item) => item.label)
              .join('/')}
          </div>
          {selectedFile.hasThumbnail && (
            <div className={'my-2'}>
              <img src={selectedFile.thumbnailLink} alt={null} />
            </div>
          )}
          <div>Ultima modifica: {formatDate(selectedFile.modifiedTime)}</div>
          <div>Dimensione: {formatSize(selectedFile.size)}</div>
          <div className={'mt-3'}>Procedere con l'upload su S3?</div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={'secondary'}
            onClick={() => {
              setSelectedFile({});
              setSelectFileModal(false);
            }}
          >
            Annulla
          </Button>
          <Button
            variant={'primary'}
            onClick={() => {
              setSelectFileModal(false);
            }}
          >
            Conferma
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={uploadModal}
        onHide={() => {
          setUploadModal(false);
          setUploadError(null);
        }}
        centered
        backdrop={!!uploadError ? true : 'static'}
        keyboard={false}
      >
        <Modal.Header closeButton={!!uploadError}>
          <Modal.Title>Upload in corso&hellip;</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>Questa operazione richiederà qualche minuto. Questo popup si chiuderà in automatico una volta completata l'operazione.</div>
          <div>
            <strong>Non abbandonare la pagina!</strong>
          </div>
        </Modal.Body>
        {!!uploadError && (
          <Modal.Footer>
            <div className={'flex-grow-1'}>
              <Alert variant={'danger'}>Si è verificato un errore nell'upload. Contattare l'amministratore fornendo le informazioni seguenti:</Alert>
              <pre className={'mb-0'}>{JSON.stringify(uploadError, null, 2)}</pre>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export default UploadComponent;
